import { Outlet, createFileRoute } from '@tanstack/react-router';

import useViewerStore, { SidebarLeftTab } from '../-utils/useViewerStore';

/**
 * This route only functions as a middleware to set the sidebar left tab id to inhoud.
 */
export const Route = createFileRoute(
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/_inhoud'
)({
  component: RouteComponent,
  onEnter: () => {
    useViewerStore.getState().setSidebarLeftTabId(SidebarLeftTab.INHOUD);
  },
});

function RouteComponent() {
  return <Outlet />;
}
